import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import {
  ChartLineUp,
  UsersThree,
  Tag,
  Calendar,
  Books,
  PaperPlaneTilt,
  ShieldStar,
  Gear,
  SignOut,
  TelegramLogo,
} from "@phosphor-icons/react";
import { ROLE_LABEL } from "@/lib/utils-format";

const navItems = [
  { to: "/", label: "Дашборд", icon: ChartLineUp, end: true, testid: "nav-dashboard" },
  { to: "/subscribers", label: "Подписчики", icon: UsersThree, testid: "nav-subscribers" },
  { to: "/tags", label: "Теги", icon: Tag, testid: "nav-tags" },
  { to: "/events", label: "Мероприятия", icon: Calendar, testid: "nav-events" },
  { to: "/programs", label: "Каталог программ", icon: Books, testid: "nav-programs" },
  { to: "/broadcasts", label: "Рассылки", icon: PaperPlaneTilt, testid: "nav-broadcasts" },
  { to: "/admins", label: "Администраторы", icon: ShieldStar, testid: "nav-admins" },
  { to: "/settings", label: "Настройки", icon: Gear, testid: "nav-settings" },
];

export default function Layout() {
  const { admin, logout } = useAuth();

  return (
    <div className="min-h-screen flex bg-zinc-950 text-zinc-100" data-testid="app-layout">
      {/* Sidebar */}
      <aside
        className="w-64 border-r border-zinc-900 bg-zinc-950 flex-shrink-0 flex flex-col fixed h-screen z-30"
        data-testid="sidebar"
      >
        <div className="px-5 py-5 border-b border-zinc-900">
          <img
            src="/stratoplan-logo.png"
            alt="Stratoplan"
            className="h-8 w-auto select-none"
            data-testid="sidebar-logo"
          />
          <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 mt-3">
            Bot Admin · CRM
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
          <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-600 px-3 mb-2">
            Управление
          </div>
          {navItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={it.testid}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition-colors ` +
                (isActive
                  ? "bg-blue-500/10 text-blue-400 border border-blue-500/20"
                  : "text-zinc-400 hover:text-zinc-100 hover:bg-zinc-900 border border-transparent")
              }
            >
              <it.icon size={16} weight="bold" />
              {it.label}
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-zinc-900 p-3">
          <div className="flex items-center justify-between px-2 py-2 rounded-md hover:bg-zinc-900 group">
            <div className="flex items-center gap-2.5 min-w-0">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center text-zinc-950 text-xs font-bold">
                {(admin?.login || "?")[0].toUpperCase()}
              </div>
              <div className="min-w-0">
                <div className="text-sm font-medium truncate" data-testid="current-admin-name">
                  {admin?.full_name || admin?.login}
                </div>
                <div className="text-[10px] uppercase tracking-wider text-zinc-500">
                  {ROLE_LABEL[admin?.role] || admin?.role}
                </div>
              </div>
            </div>
            <button
              onClick={logout}
              data-testid="logout-btn"
              className="text-zinc-500 hover:text-red-400 opacity-0 group-hover:opacity-100 transition-opacity"
              title="Выйти"
            >
              <SignOut size={16} />
            </button>
          </div>
          <a
            href="https://t.me/Stratoplan_manager_bot"
            target="_blank"
            rel="noreferrer"
            className="mt-2 flex items-center gap-2 text-[10px] uppercase tracking-wider text-zinc-600 hover:text-[#2AABEE] px-2 py-1.5 transition-colors"
          >
            <TelegramLogo size={12} weight="fill" />
            Telegram support
          </a>
        </div>
      </aside>

      {/* Main */}
      <main className="ml-64 flex-1 min-w-0">
        <div className="px-8 py-6 fade-up">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
